import { render, staticRenderFns } from "./ButtonItem.vue?vue&type=template&id=0d5e0d15&scoped=true"
import script from "./ButtonItem.vue?vue&type=script&lang=js"
export * from "./ButtonItem.vue?vue&type=script&lang=js"
import style0 from "./ButtonItem.vue?vue&type=style&index=0&id=0d5e0d15&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5e0d15",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d5e0d15')) {
      api.createRecord('0d5e0d15', component.options)
    } else {
      api.reload('0d5e0d15', component.options)
    }
    module.hot.accept("./ButtonItem.vue?vue&type=template&id=0d5e0d15&scoped=true", function () {
      api.rerender('0d5e0d15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ButtonItem.vue"
export default component.exports